import { FC } from 'react';

import SearchInput from './search-input.component';

const Desktop: FC = () => {
  return (
    <form className="app-search d-none d-lg-block">
      <div className="position-relative">
        <SearchInput />
        <span className="bx bx-search-alt" />
      </div>
    </form>
  );
};

export default Desktop;
